import React, { FC, ReactNode } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { Grid } from '@mui/material'

const useStyles = makeStyles()((theme: Theme) => ({
  wrapper: {
    minHeight: theme.spacing(37),
    padding: theme.spacing(3),
  },
}))

const NoDataCard: FC<{ children?: ReactNode }> = ({ children }) => {
  const { classes } = useStyles()

  return (
    <Grid className={classes.wrapper} data-testid={'no-data'}>
      {children}
    </Grid>
  )
}

export default NoDataCard
